import { z } from 'zod'
import { staffRoleSchema } from '../enums/staff-role.enum.js'
import { uuidSchema } from '../validators/params.js'

/** The authenticated user shape the API returns and the web app stores. */
export const authUserDtoSchema = z.object({
  id: uuidSchema,
  email: z.string().email(),
  name: z.string(),
  /** For rendering only — the API enforces the role on every request. */
  role: staffRoleSchema,
})

export type AuthUserDto = z.infer<typeof authUserDtoSchema>

/** Response from `POST /auth/login`. */
export const loginResponseDtoSchema = z.object({
  accessToken: z.string(),
  user: authUserDtoSchema,
})

export type LoginResponseDto = z.infer<typeof loginResponseDtoSchema>
